import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  imports: [CommonModule, MatButtonModule, RouterModule, MatSnackBarModule],
  exports: [MatButtonModule, RouterModule, MatSnackBarModule]
})
export class SharedModule {}
